<template>
  <EditarBase
    :itemAtual="itemAtual"
    :recursoInicial="recursoInicial"
    nomeSingular="FuncionarioSindicato"
    nomePlural="FuncionarioSindicatos"
    @recurso="recurso = $event"
    :submitPersonalizado="true"
    @submitSuccess="emitSubmitSuccess"
    @submitError="emitSubmitError"
    @closeModalEdit="closeModalEdit"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <span class="opacity-5 text-dark">
            {{ $t("Descricao") }}
          </span>
          <v-text-field
            v-model="recurso.descricao"
            :label="$t('Descricao')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <CriaSuperSet
            :podeEditarRecursoFinal="true"
            @recursos="recurso.rubricas = $event"
            :payload="recurso.rubricas"
            :usaRecursoBase="false"
            tituloFinais="Rubricas_exportacao_folha_pagamento"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="headersRubricas"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->
              <v-col cols="12" md="12">
                <v-select
                  :items="itensRubricasSindicato"
                  :rules="rule_required"
                  :label="$t('Tipo')"
                  id="tipo"
                  v-model="slotProps.recursoFinalAtual.tipo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="
                  deveMostrarCampo(
                    'tipo_apuracao',
                    slotProps.recursoFinalAtual.tipo,
                  )
                "
              >
                <v-select
                  :items="[
                    {
                      text: $t('Dia'),
                      value: 'DIA',
                    },
                    {
                      text: $t('Hora'),
                      value: 'HORA',
                    },
                  ]"
                  :label="$t('Tipo_apuracao')"
                  id="tipo_apuracao"
                  :rules="rule_required"
                  :hint="$t('Tipo_apuracao_rubrica_dica')"
                  persistent-hint
                  v-model="slotProps.recursoFinalAtual.tipoApuracao"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :rules="rule_required"
                  v-model="slotProps.recursoFinalAtual.rubrica"
                  :label="$t('Rubrica')"
                  :hint="dicaRubrica(slotProps.recursoFinalAtual.tipo)"
                  persistent-hint
                  name="rubrica"
                  id="rubrica_cod"
                >
                </v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="possuiIntegracaoFpSIPFolhaPagamento"
              >
                <v-select
                  :items="tiposApuracaoFp"
                  :label="$t('Tipo_apuracao_fp')"
                  :hint="$t('Tipo_apuracao_fp_dica')"
                  persistent-hint
                  id="tipo_apuracao_fp"
                  v-model="slotProps.recursoFinalAtual.tipoApuracaoFp"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="possuiIntegracaoFpSIPFolhaPagamento"
              >
                <v-text-field
                  v-model="slotProps.recursoFinalAtual.descricaoFp"
                  :label="$t('Descricao_fp')"
                  name="descricaoFp"
                  id="descricao_fp"
                >
                </v-text-field>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <v-col cols="12" md="12">
                <v-select
                  :items="itensRubricasSindicato"
                  :label="$t('Tipo')"
                  v-model="slotProps.recursoFinalAtual.tipo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                md="6"
                v-if="
                  deveMostrarCampo(
                    'tipo_apuracao',
                    slotProps.recursoFinalAtual.tipo,
                  )
                "
              >
                <v-select
                  :items="[
                    {
                      text: $t('Dia'),
                      value: 'DIA',
                    },
                    {
                      text: $t('Hora'),
                      value: 'HORA',
                    },
                  ]"
                  :label="$t('Tipo_apuracao')"
                  :hint="$t('Tipo_apuracao_rubrica_dica')"
                  persistent-hint
                  v-model="slotProps.recursoFinalAtual.tipoApuracao"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  :rules="rule_required"
                  v-model="slotProps.recursoFinalAtual.rubrica"
                  :label="$t('Rubrica')"
                  :hint="dicaRubrica(slotProps.recursoFinalAtual.tipo)"
                  persistent-hint
                  name="rubrica"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="possuiIntegracaoFpSIPFolhaPagamento"
              >
                <v-select
                  :items="tiposApuracaoFp"
                  :label="$t('Tipo_apuracao_fp')"
                  :hint="$t('Tipo_apuracao_fp_dica')"
                  persistent-hint
                  v-model="slotProps.recursoFinalAtual.tipoApuracaoFp"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="possuiIntegracaoFpSIPFolhaPagamento"
              >
                <v-text-field
                  v-model="slotProps.recursoFinalAtual.descricaoFp"
                  :label="$t('Descricao_fp')"
                  name="descricaoFp"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12">
          <CompensacaoHorasSindicato :recurso="recurso" />
        </v-col>

        <v-col cols="12">
          <RegrasTipoDiaSindicato :recurso="recurso" />
        </v-col>

        <v-col cols="12">
          <CriaSuperSet
            :podeEditarRecursoFinal="true"
            @recursos="recurso.parametrizacoes = $event"
            :usaRecursoBase="false"
            :payload="recurso.parametrizacoes"
            tituloFinais="Parametrizacoes_calculo_ponto"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              {
                text: this.$t('Tipo'),
                value: 'tipo',
                sortable: 'true',
              },
              {
                text: this.$t('Referencia'),
                value: 'referencia',
                sortable: 'true',
              },

              {
                text: this.$t('Ativo'),
                value: 'ativo',
                sortable: 'true',
              },

              { text: this.$t('Acoes'), value: 'actions', sortable: 'false' },
            ]"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->
              <v-col cols="12" md="12">
                <v-select
                  :items="[
                    { text: $t('COMPENSARHORAS'), value: 'COMPENSARHORAS' },
                    {
                      text: $t(
                        'COMPENSARFALTAINJUSTIFICADAEMFOLGASTRABALHADAS',
                      ),
                      value: 'COMPENSARFALTAINJUSTIFICADAEMFOLGASTRABALHADAS',
                    },
                    // { text: $t('BANCOHORAS'), value: 'BANCOHORAS' },
                    {
                      text: $t('HORAEXTRAFERIADOINTERMITENTE'),
                      value: 'HORAEXTRAFERIADOINTERMITENTE',
                    },
                    {
                      text: $t('HORAEXTRA100INTERMITENTE'),
                      value: 'HORAEXTRA100INTERMITENTE',
                    },
                    {
                      text: $t('CONVERTERCOMPENSAREMATRASO'),
                      value: 'CONVERTERCOMPENSAREMATRASO',
                    },
                    {
                      text: $t('ADICIONARABONOEMHORAEXTRA'),
                      value: 'ADICIONARABONOEMHORAEXTRA',
                    },
                    {
                      text: $t('FOLGAFERIADOINTERMITENTEEXCETO12X36'),
                      value: 'FOLGAFERIADOINTERMITENTEEXCETO12X36',
                    },
                    {
                      text: $t(
                        'FOLGAFERIADOINTERMITENTEEXCETO12X36EXCETODOMINGOS',
                      ),
                      value:
                        'FOLGAFERIADOINTERMITENTEEXCETO12X36EXCETODOMINGOS',
                    },
                    {
                      text: $t('APURARHSNOTURNAPRORROGADA'),
                      value: 'APURARHSNOTURNAPRORROGADA',
                    },
                    {
                      text: $t('APURARVAVTJORNADAMENORQUE6HORAS'),
                      value: 'APURARVAVTJORNADAMENORQUE6HORAS',
                    },
                    {
                      text: $t('ABATERINTRAJORNADAEMHE'),
                      value: 'ABATERINTRAJORNADAEMHE',
                    },
                    // {
                    //   text: $t('ABATERINTRAJORNADAEMHE100'),
                    //   value: 'ABATERINTRAJORNADAEMHE100',
                    // },
                    {
                      text: $t('EXTENSAOINTRAJORNADAMAXIMAMINUTOS'),
                      value: 'EXTENSAOINTRAJORNADAMAXIMAMINUTOS',
                    },
                    {
                      text: $t(
                        'APURARFALTAINJUSTIFICADAHORASQUANDOAPENASHORASABONADAS',
                      ),
                      value:
                        'APURARFALTAINJUSTIFICADAHORASQUANDOAPENASHORASABONADAS',
                    },
                    {
                      text: $t('ACRESCIMOAPURACAOVACOM2HE'),
                      value: 'ACRESCIMOAPURACAOVACOM2HE',
                    },
                    {
                      text: $t('APURARHORANOTURNACHEIA'),
                      value: 'APURARHORANOTURNACHEIA',
                    },
                    {
                      text: $t('JORNADAMINIMAPARAINTRAJORNADAMINUTOS'),
                      value: 'JORNADAMINIMAPARAINTRAJORNADAMINUTOS',
                    },
                    {
                      text: $t('HORAEXTRATIPO160'),
                      value: 'HORAEXTRATIPO160',
                    },
                    {
                      text: $t('HORAEXTRATIPO170'),
                      value: 'HORAEXTRATIPO170',
                    },
                    {
                      text: $t('HORAEXTRATIPO160SABADOS'),
                      value: 'HORAEXTRATIPO160SABADOS',
                    },
                    {
                      text: $t('REMOVERCOMPENSACAOSOBREAVISO'),
                      value: 'REMOVERCOMPENSACAOSOBREAVISO',
                    },
                    {
                      text: $t('REMOVERCOMPENSACAOATRASO'),
                      value: 'REMOVERCOMPENSACAOATRASO',
                    },
                    {
                      text: $t('HEEXTRASEMPREBH'),
                      value: 'HEEXTRASEMPREBH',
                    },
                    {
                      text: $t('DESABILITARHEINCOMPENSAVEL'),
                      value: 'DESABILITARHEINCOMPENSAVEL',
                    },
                    {
                      text: $t('DESABILITARTOLERANCIA10MINHORANOTURNA'),
                      value: 'DESABILITARTOLERANCIA10MINHORANOTURNA',
                    },
                    {
                      text: $t('HABILITARDSRSOBREFALTA12X36'),
                      value: 'HABILITARDSRSOBREFALTA12X36',
                    },
                    {
                      text: $t('DESATIVARAPURACAODSRHORAEXTRA'),
                      value: 'DESATIVARAPURACAODSRHORAEXTRA',
                    },
                    {
                      text: $t('DESATIVARAPURACAODSRFALTAINJUSTIFICADA'),
                      value: 'DESATIVARAPURACAODSRFALTAINJUSTIFICADA',
                    },
                    {
                      text: $t('CONVERTERHE50ACIMADE2HSPARAHE100'),
                      value: 'CONVERTERHE50ACIMADE2HSPARAHE100',
                    },
                    {
                      text: $t('INTERVALOMINIMOENTREREGISTROS'),
                      value: 'INTERVALOMINIMOENTREREGISTROS',
                    },
                    {
                      text: $t('INTERJORNADAHORASPARAAPURACAO'),
                      value: 'INTERJORNADAHORASPARAAPURACAO',
                    },
                    {
                      text: $t('DESATIVARAPURACAOINTERJORNADA'),
                      value: 'DESATIVARAPURACAOINTERJORNADA',
                    },
                    {
                      text: $t('APURASEXTRASAPENASPORCOMPETENCIA'),
                      value: 'APURASEXTRASAPENASPORCOMPETENCIA',
                    },
                    {
                      text: $t('APURACAOBANCODEHORASCOMPENSACAO90DIAS'),
                      value: 'APURACAOBANCODEHORASCOMPENSACAO90DIAS',
                    },
                    {
                      text: $t('BONIFICACAOBANCODEHORASANUAL'),
                      value: 'BONIFICACAOBANCODEHORASANUAL',
                    },
                    {
                      text: $t('APURARHORASABONADASCOMOREDUCAOJORNADA'),
                      value: 'APURARHORASABONADASCOMOREDUCAOJORNADA',
                    },
                    {
                      text: $t('AGRUPARHORASNOTURNASENOTURNASREDUZIDAS'),
                      value: 'AGRUPARHORASNOTURNASENOTURNASREDUZIDAS',
                    },
                    {
                      text: $t('ENVIARPARAFOLHAPAGAMENTOAPENASHORASAPROVADAS'),
                      value: 'ENVIARPARAFOLHAPAGAMENTOAPENASHORASAPROVADAS',
                    },
                    {
                      text: $t('REMOVERTOLERANCIAHORASINCOMPENSAVEIS'),
                      value: 'REMOVERTOLERANCIAHORASINCOMPENSAVEIS',
                    },
                    {
                      text: $t('DSRFALTAINJUSTIFICADA12X36SEGREGADO'),
                      value: 'DSRFALTAINJUSTIFICADA12X36SEGREGADO',
                    },
                    {
                      text: $t('FERIADOTRABALHADO'),
                      value: 'FERIADOTRABALHADO',
                    },
                    {
                      text: $t(
                        'ABATERFALTAINJUSTIFICADAAPENASSEEXISTIRSALDOBH'
                      ),
                      value: 'ABATERFALTAINJUSTIFICADAAPENASSEEXISTIRSALDOBH',
                    },
                  ]"
                  :rules="rule_required"
                  :label="$t('Tipo')"
                  v-model="slotProps.recursoFinalAtual.tipo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="
                  deveMostrarCampo(
                    'referencia',
                    slotProps.recursoFinalAtual.tipo,
                  )
                "
              >
                <v-text-field
                  :rules="rule_required"
                  v-model="slotProps.recursoFinalAtual.referencia"
                  :label="$t('Referencia')"
                  name="referencia"
                  type="number"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-checkbox v-model="slotProps.recursoFinalAtual.ativo">
                  <template v-slot:label>
                    {{ $t("Ativo") }}
                  </template>
                </v-checkbox>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <v-col cols="12" md="12">
                <v-select
                  :items="[
                    { text: $t('COMPENSARHORAS'), value: 'COMPENSARHORAS' },
                    {
                      text: $t(
                        'COMPENSARFALTAINJUSTIFICADAEMFOLGASTRABALHADAS',
                      ),
                      value: 'COMPENSARFALTAINJUSTIFICADAEMFOLGASTRABALHADAS',
                    },
                    { text: $t('BANCOHORAS'), value: 'BANCOHORAS' },
                  ]"
                  :label="$t('Tipo')"
                  v-model="slotProps.recursoFinalAtual.tipo"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>

              <v-col
                cols="12"
                md="6"
                v-if="
                  deveMostrarCampo(
                    'referencia',
                    slotProps.recursoFinalAtual.tipo,
                  )
                "
              >
                <v-text-field
                  :rules="rule_required"
                  v-model="slotProps.recursoFinalAtual.referencia"
                  :label="$t('Referencia')"
                  name="referencia"
                  type="number"
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="slotProps.recursoFinalAtual.ativo"
                  :value="false"
                >
                  <template v-slot:label>
                    {{ $t("Ativo") }}
                  </template>
                </v-checkbox>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12">
          <CriaSuperSet
            :payload="recurso.apuracoesBh"
            :podeEditarRecursoFinal="true"
            @recursos="recurso.apuracoesBh = $event"
            :usaRecursoBase="false"
            tituloFinais="Apuracoes_banco_horas"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              {
                text: this.$t('Tipo'),
                value: 'tipo',
                sortable: 'true',
              },

              { text: this.$t('Acoes'), value: 'actions', sortable: 'false' },
            ]"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->
              <v-col cols="12" md="12">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensParametrizacoes"
                  item-text="text"
                  item-value="value"
                  :rules="rule_required"
                  label="Tipo"
                  single-line
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <!-- Form edita recurso final -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensParametrizacoes"
                  item-text="text"
                  item-value="value"
                  label="Tipo"
                  single-line
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12">
          <CriaSuperSet
            :payload="recurso.apuracoesFolhaPonto"
            :podeEditarRecursoFinal="true"
            @recursos="recurso.apuracoesFolhaPonto = $event"
            :usaRecursoBase="false"
            tituloFinais="ApuracoesFolhaPonto"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              {
                text: this.$t('Tipo'),
                value: 'tipo',
                sortable: 'true',
              },

              { text: this.$t('Acoes'), value: 'actions', sortable: 'false' },
            ]"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->
              <v-col cols="12" md="12">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensParametrizacoes"
                  item-text="text"
                  item-value="value"
                  :rules="rule_required"
                  label="Tipo"
                  single-line
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <!-- Form edita recurso final -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensParametrizacoes"
                  item-text="text"
                  item-value="value"
                  label="Tipo"
                  single-line
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12" v-if="inquilinoOrgaoPublico">
          <CriaSuperSet
            :payload="recurso.apuracoesArmazenamento"
            :podeEditarRecursoFinal="true"
            @recursos="recurso.apuracoesArmazenamento = $event"
            :usaRecursoBase="false"
            tituloFinais="Apuracoes_armazenamento"
            subtituloFinais="Apuracoes_armazenamento_ajuda"
            :headersFinais="[
              { text: $t('Tipo'), value: 'tipo', sortable: true },
              { text: $t('Acoes'), value: 'actions', sortable: false },
            ]"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <!-- Form cria recurso final -->
              <v-col cols="12" md="12">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensParametrizacoes"
                  :rules="rule_required"
                  :label="$t('Tipo')"
                  single-line
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <!-- Form edita recurso final -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensParametrizacoes"
                  :rules="rule_required"
                  :label="$t('Tipo')"
                  single-line
                  class="
                    input-style
                    font-size-input
                    text-light-input
                    placeholder-light
                    input-icon
                  "
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12" v-if="inquilinoOrgaoPublico">
          <CriaSuperSet
            :payload="recurso.limitesApuracaoDiaria"
            :podeEditarRecursoFinal="true"
            @recursos="recurso.limitesApuracaoDiaria = $event"
            :usaRecursoBase="false"
            tituloFinais="Limites_apuracao_diaria"
            subtituloFinais="Clique_para_adicionar"
            :headersFinais="[
              { text: $t('Tipo'), value: 'tipo', sortable: true },
              {
                text: $t('Limite_diario'),
                value: 'limiteDiario',
                sortable: true,
              },
              { text: $t('Acoes'), value: 'actions', sortable: false },
            ]"
            textoBotaoCadastro="Criar_item"
          >
            <template v-slot:default="slotProps">
              <v-col cols="12" md="6">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensLimitesApuracaoDiaria"
                  :rules="rule_required"
                  :label="$t('Tipo')"
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="slotProps.recursoFinalAtual.limiteDiario"
                  :rules="regrasLimiteDiario"
                  :label="$t('Limite_diario')"
                  type="number"
                  step="any"
                  min="0"
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>
            </template>
            <template v-slot:formEditaRecursoFinal="slotProps">
              <v-col cols="12" md="6">
                <v-select
                  v-model="slotProps.recursoFinalAtual.tipo"
                  :items="itensLimitesApuracaoDiaria"
                  :rules="rule_required"
                  :label="$t('Tipo')"
                  dense
                  flat
                  filled
                  solo
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="slotProps.recursoFinalAtual.limiteDiario"
                  :rules="regrasLimiteDiario"
                  :label="$t('Limite_diario')"
                  type="number"
                  step="any"
                  min="0"
                  dense
                  flat
                  filled
                  solo
                ></v-text-field>
              </v-col>
            </template>
          </CriaSuperSet>
        </v-col>

        <v-col cols="12" md="4">
          <span class="opacity-5 text-dark">
            {{ $t("bancoHorasmaximoHorasAcumuladas") }}
          </span>
          <v-text-field
            v-model.number="recurso.bancoHorasmaximoHorasAcumuladas"
            :label="$t('bancoHorasmaximoHorasAcumuladas')"
            name="bancoHorasmaximoHorasAcumuladas"
            type="number"
            step="any"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="opacity-5 text-dark">
            {{ $t("bancoHorasMaximoHorasDia") }}
          </span>
          <v-text-field
            v-model.number="recurso.bancoHorasMaximoHorasDia"
            :label="$t('bancoHorasMaximoHorasDia')"
            name="bancoHorasMaximoHorasDia"
            type="number"
            step="any"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <span class="opacity-5 text-dark">
            {{ $t("bancoHorasMinimoHorasDia") }}
          </span>
          <v-text-field
            v-model.number="recurso.bancoHorasMinimoHorasDia"
            :label="$t('bancoHorasMinimoHorasDia')"
            name="bancoHorasMinimoHorasDia"
            type="number"
            step="any"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-checkbox v-model="recurso.bancoHorasUtilizarMultiplicadorVolatil">
            <template v-slot:label>
              {{ $t("bancoHorasUtilizarMultiplicadorVolatil") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" v-if="envioEsocialAtivo">
          <CamposEsocialSindicato :recurso="recurso" />
        </v-col>
      </v-row>
    </v-col>
  </EditarBase>
</template>

<script>
import EditarBase from "@/components/base/Crud/EditarBase";
import CriaSuperSet from "@/components/base/proprios/CriaSuperset.vue";
import CamposEsocialSindicato from "@/components/pessoal/esocial-envio/CamposEsocialSindicato.vue";
import envioAtivo from "@/components/pessoal/esocial-envio/envioAtivo";
import listas from "@/mixins/listas";
import FuncionarioSindicatoDataService from "@/services/pessoal/FuncionarioSindicatoDataService";
import { validarNiveis } from "@/utils/regrasTipoDia";
import CompensacaoHorasSindicato from "./CompensacaoHorasSindicato.vue";
import RegrasTipoDiaSindicato from "./RegrasTipoDiaSindicato.vue";
const DataService = FuncionarioSindicatoDataService;

// Rubricas em valor (R$) vindas da apuração de benefícios: não têm tipo de apuração (hora/dia).
const TIPOS_RUBRICA_BENEFICIO = [
  "DESCONTOALIMENTACAO",
  "DESCONTOVALEALIMENTACAO",
  "DESCONTOVALEREFEICAO",
  "DESCONTOTRANSPORTE",
  "DESCONTOPLANOSAUDE",
  "DESCONTOPLANOODONTOLOGICO",
  "DESCONTOSEGUROVIDA",
  "DESCONTOAUXILIOFUNERAL",
  "DESCONTOAJUDACUSTO",
  "CREDITOAJUDACUSTO",
];
// Apurações que o ponto gera e que não estão na lista geral de parametrizações.
const TIPOS_RUBRICA_PONTO_EXTRAS = [
  "EXTRA70INCOMPENSAVEL",
  "SALDOBANCOHORASNAOCOMPENSADO",
  "AUSENCIAMANUAL",
  "INSS",
  "LICENCAMATERNIDADE",
  "LICENCAPATERNIDADE",
  "LICENCALUTO",
  "LICENCAGALA",
];

export default {
  props: {
    itemAtual: { type: Object, required: false, default: null },
    recursoInicial: { type: Object, required: false, default: null },
  },
  name: "EditarFuncionarioSindicato",
  components: {
    EditarBase,
    CriaSuperSet,
    CompensacaoHorasSindicato,
    RegrasTipoDiaSindicato,
    CamposEsocialSindicato,
  },
  mixins: [listas, envioAtivo],
  data() {
    return {
      DataService: DataService,
      submited: false,

      recurso: {
        descricao: "",
        bancoHorasmaximoHorasAcumuladas: null,
        bancoHorasMaximoHorasDia: null,
        bancoHorasMinimoHorasDia: null,
        bancoHorasUtilizarMultiplicadorVolatil: false,
        compensacaoPersonalizada: false,
        compensacaoCreditos: [],
        compensacaoDebitos: [],
        niveisHora: [],
        tolerancias: [],
        rubricas: [],
        parametrizacoes: [],
        limitesApuracaoDiaria: [],
        apuracoesArmazenamento: [],
      },

      errors: [],

      itensStatusComum: [
        { text: this.$t("Ativo"), value: "ATIVO" },
        { text: this.$t("Inativo"), value: "INATIVO" },
      ],
    };
  },

  computed: {
    inquilinoOrgaoPublico() {
      return this.$store?.state?.inquilino?.tipoContratacao === "ORGAOPUBLICO";
    },
    regrasLimiteDiario() {
      return [
        (valor) =>
          (valor !== null &&
            valor !== undefined &&
            valor !== "" &&
            Number.isFinite(Number(valor)) &&
            Number(valor) >= 0) ||
          this.$t("Limite_diario_invalido"),
      ];
    },
    possuiIntegracaoFpSIPFolhaPagamento() {
      return !!(
        this.$store.state.inquilino &&
        this.$store.state.inquilino.parametrizacoes &&
        this.$store.state.inquilino.parametrizacoes.find(
          (item) => item.tipo == "INTEGRACAO_FP_SIP_FOLHA_PAGAMENTO",
        )
      );
    },
    tiposApuracaoFp() {
      return [
        { text: this.$t("QUANTIDADE"), value: "QUANTIDADE" },
        { text: this.$t("PORCENTAGEM"), value: "PORCENTAGEM" },
        { text: this.$t("VALOR"), value: "VALOR" },
        { text: this.$t("HORA"), value: "HORA" },
        { text: this.$t("DIA"), value: "DIA" },
        { text: this.$t("DECIMAL"), value: "DECIMAL" },
      ];
    },
    // O limite diário é aplicado antes de a hora extra 100% virar Feriado: o limite da Extra 100% já vale para o feriado.
    // A falta injustificada só vai ao banco de horas no período, sem apuração diária para limitar.
    itensLimitesApuracaoDiaria() {
      return this.itensParametrizacoes.filter(
        (i) =>
          i.value !== "FERIADO" && i.value !== "FALTA_INJUSTIFICADA_BANCO_HORAS"
      );
    },
    itensRubricasSindicato() {
      const item = (value) => ({ text: this.$t(value), value });
      const ponto = this.itensParametrizacoes
        .filter((i) => !TIPOS_RUBRICA_BENEFICIO.includes(i.value))
        .concat(
          TIPOS_RUBRICA_PONTO_EXTRAS.filter(
            (t) => !this.itensParametrizacoes.some((i) => i.value === t),
          ).map(item),
        );
      return [
        { header: this.$t("Rubricas_grupo_ponto") },
        ...ponto,
        { divider: true },
        { header: this.$t("Rubricas_grupo_beneficios") },
        ...TIPOS_RUBRICA_BENEFICIO.map(item),
      ];
    },
    headersRubricas() {
      const headers = [
        {
          text: this.$t("Rubrica"),
          value: "rubrica",
          sortable: "true",
        },
        {
          text: this.$t("Tipo"),
          value: "tipo",
          sortable: "true",
        },
        {
          text: this.$t("Tipo_apuracao"),
          value: "tipoApuracao",
          sortable: "true",
        },
      ];

      if (this.possuiIntegracaoFpSIPFolhaPagamento) {
        headers.push(
          {
            text: this.$t("Tipo_apuracao_fp"),
            value: "tipoApuracaoFp",
            sortable: "true",
          },
          {
            text: this.$t("Descricao_fp"),
            value: "descricaoFp",
            sortable: "true",
          },
        );
      }

      headers.push({
        text: this.$t("Acoes"),
        value: "actions",
        sortable: "false",
      });

      return headers;
    },
  },

  methods: {
    emitSubmitSuccess(recursoAtualizado = this.recurso) {
      this.$emit("submitSuccess", recursoAtualizado);
    },
    emitSubmitError() {
      this.$emit("submitError");
    },
    closeModalEdit() {
      this.$emit("closeModalEdit");
    },
    submitForm() {
      let recurso = this.recurso;
      recurso.parametrizacoes = recurso.parametrizacoes.map((item) => {
        if (item.ativo == null) {
          item.ativo = false;
        }
        return item;
      });
      [
        "bancoHorasmaximoHorasAcumuladas",
        "bancoHorasMaximoHorasDia",
        "bancoHorasMinimoHorasDia",
      ].forEach((campo) => {
        if (recurso[campo] === "") {
          recurso[campo] = null;
        }
      });
      if (recurso.bancoHorasUtilizarMultiplicadorVolatil == null) {
        recurso.bancoHorasUtilizarMultiplicadorVolatil = false;
      }

      const errosFaixas = validarNiveis(recurso.niveisHora);
      if (errosFaixas.length) {
        return Promise.reject(
          errosFaixas.map((erro) => ({
            fieldName: this.$t("Regras_aba_faixas"),
            message: this.$t(erro),
          })),
        );
      }

      return new Promise((resolve, reject) => {
        DataService.update(this.limpaMascara(recurso))
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err.response.data.errors);
          });
      });
    },
    deveMostrarCampo(campo, tipo) {
      if (campo == "referencia") {
        if (tipo == "COMPENSARHORAS") {
          return false;
        }
        if (tipo == "COMPENSARFALTAINJUSTIFICADAEMFOLGASTRABALHADAS") {
          return false;
        }
        if (tipo == "HORAEXTRAFERIADOINTERMITENTE") {
          return false;
        }
        if (tipo == "HORAEXTRA100INTERMITENTE") {
          return false;
        }
        if (tipo == "CONVERTERCOMPENSAREMATRASO") {
          return false;
        }
        if (tipo == "ADICIONARABONOEMHORAEXTRA") {
          return false;
        }
        if (tipo == "FOLGAFERIADOINTERMITENTEEXCETO12X36") {
          return false;
        }
        if (tipo == "FOLGAFERIADOINTERMITENTEEXCETO12X36EXCETODOMINGOS") {
          return false;
        }
        if (tipo == "APURASEXTRASAPENASPORCOMPETENCIA") {
          return false;
        }

        if (tipo == "APURARHSNOTURNAPRORROGADA") {
          return false;
        }
        if (tipo == "APURARVAVTJORNADAMENORQUE6HORAS") {
          return true;
        }
        if (tipo == "ABATERINTRAJORNADAEMHE") {
          return false;
        }
        if (tipo == "ABATERINTRAJORNADAEMHE100") {
          return false;
        }

        if (tipo == "EXTENSAOINTRAJORNADAMAXIMAMINUTOS") {
          return true;
        }
        if (tipo == "JORNADAMINIMAPARAINTRAJORNADAMINUTOS") {
          return true;
        }
        if (tipo == "APURARFALTAINJUSTIFICADAHORASQUANDOAPENASHORASABONADAS") {
          return false;
        }
        if (tipo == "ACRESCIMOAPURACAOVACOM2HE") {
          return false;
        }
        if (tipo == "INTERVALOMINIMOENTREREGISTROS") {
          return true;
        }
        if (tipo == "INTERJORNADAHORASPARAAPURACAO") {
          return true;
        }
        if (tipo == "BONIFICACAOBANCODEHORASANUAL") {
          return true;
        }
      } else if (campo == "tipo_apuracao") {
        return !TIPOS_RUBRICA_BENEFICIO.includes(tipo);
      }
    },
    dicaRubrica(tipo) {
      return TIPOS_RUBRICA_BENEFICIO.includes(tipo)
        ? this.$t("Rubrica_beneficio_dica")
        : "";
    },
  },
};
</script>

<style scoped></style>
